export const PRODUCT_SLOGANS = {
  turbo:
    "Turborepo 是一个针对 JavaScript 和 TypeScript 优化的构建系统，使用 Rust 编写。",
  repo: "The build system that makes ship happen.",
} as const;

export const gitHubRepoUrl = "https://github.com/vercel/turborepo";
export const PRODUCT_DOMAIN = "turborepo.com";
export const PREVIEW_DOMAIN_SUFFIX = "vercel.sh";
